import {
    DEALER_LICENCE,
    DEALERS_CONTACT_PERSON_DETAILS,
    DEALERS_LICENCE_MAILING_ADDRESS,
    OTHER_DETAILS,
    EQUIPMENT_INFORMATION,
    TECHNICAL_DATA_INFORMATION,
    EQUIPMENT_TECHNICAL_DATA_LINE,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/COFCLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import { findCountryByCode } from 'utils/utils';

export const formatCOFC = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'confirmation-of-conformity',
        formID: 'confirmation-of-conformity',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${DEALER_LICENCE}-dealer-licence-no`]: licenceDetails?.applicationInformation?.dealerLicenceNo ?? '-',
            [`${DEALER_LICENCE}-dealer-licence-company-name`]: licenceDetails?.applicationInformation?.dealerSLicenceCompanyName ?? '-',
            [`${DEALER_LICENCE}-scheme-type`]: licenceDetails?.applicationInformation?.schemeType ?? '-',

            [`${DEALERS_CONTACT_PERSON_DETAILS}-same-as-applicant-particulars`]:
                licenceDetails?.contactPersonParticulars?.sameAsApplicantParticulars ?? '-',
            [`${DEALERS_CONTACT_PERSON_DETAILS}-name`]: licenceDetails?.contactPersonParticulars?.name ?? '-',
            [`${DEALERS_CONTACT_PERSON_DETAILS}-designation`]: licenceDetails?.contactPersonParticulars?.designation ?? '-',
            [`${DEALERS_CONTACT_PERSON_DETAILS}-email`]: licenceDetails?.contactPersonParticulars?.email ?? '-',
            [`${DEALERS_CONTACT_PERSON_DETAILS}-office-tel-number`]: licenceDetails?.contactPersonParticulars?.officeTelNumber ?? '-',
            [`${DEALERS_CONTACT_PERSON_DETAILS}-mobile-number`]: licenceDetails?.contactPersonParticulars?.mobileNumber ?? '-',
            [`${DEALERS_CONTACT_PERSON_DETAILS}-fax-number`]: licenceDetails?.contactPersonParticulars?.faxNumber ?? '-',

            [`${DEALERS_LICENCE_MAILING_ADDRESS}-same-as-applicant-particulars`]:
                licenceDetails?.contactPersonAddress?.sameAsApplicantAddress ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-building-name`]: licenceDetails?.contactPersonAddress?.address?.buildingName ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-postal-code`]: licenceDetails?.contactPersonAddress?.address?.postalCode ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-street-name`]: licenceDetails?.contactPersonAddress?.address?.streetName ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-block-house-no`]: licenceDetails?.contactPersonAddress?.address?.blockNo ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-floor-level-optional`]: licenceDetails?.contactPersonAddress?.address?.floor ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-unit-optional`]: licenceDetails?.contactPersonAddress?.address?.unit ?? '-',

            [`${OTHER_DETAILS}-public-contact-no`]: licenceDetails?.otherDetails?.publicContactNo ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${EQUIPMENT_INFORMATION}-cofc-equipment-type`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTypeForConfirmationOfConformityCofcEquipmentType[0]?.mixedValue ?? '-',
            [`${EQUIPMENT_INFORMATION}-mandatory-imda-spec-no-desc`]:
                licenceDetails?.equipmentInfo[0]?.mandatoryImdaSpecNoDesc[0]?.mixedValue ?? '-',
            [`${EQUIPMENT_INFORMATION}-equipment-description`]: licenceDetails?.equipmentInfo[0]?.equipmentDescription ?? '-',
            [`${EQUIPMENT_INFORMATION}-brand-trade-name`]: licenceDetails?.equipmentInfo[0]?.brandTradeName ?? '-',
            [`${EQUIPMENT_INFORMATION}-model-no`]: licenceDetails?.equipmentInfo[0]?.modelNo ?? '-',
            [`${EQUIPMENT_INFORMATION}-marketing-name`]: licenceDetails?.equipmentInfo[0]?.marketingName ?? '-',
            [`${EQUIPMENT_INFORMATION}-manufacturer-name`]: licenceDetails?.equipmentInfo[0]?.manufacturerName ?? '-',
            [`${EQUIPMENT_INFORMATION}-manufacturer-country`]:
                findCountryByCode(licenceDetails?.equipmentInfo[0]?.manufacturerNameCountry),
            [`${EQUIPMENT_INFORMATION}-country-of-origin`]: licenceDetails?.equipmentInfo[0]?.countryOfOriginImportCountry ?? '-',
            [`${EQUIPMENT_INFORMATION}-network-connection`]:
                licenceDetails?.equipmentInfo[0]?.networkConnection.map((connection: any) => connection.mixedValue).join(', ') ?? '-',

            [`${TECHNICAL_DATA_INFORMATION}-test-lab-name`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.testLabName ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-test-report-no`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.testReportNo ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-country-of-lab`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.countryOfLab ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-applied-for`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.appliedFor[0]?.mixedValue ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-auto-dial-feature`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.autoDialFeature ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-protocol`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.protocalType ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-type-of-customer-interface`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.typeOfCustomerInterface ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-line-ports`]: licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.linePorts ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-list-of-customised-terminals-used`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.listOfCustomisedTerminalsUsed ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-list-of-network-interface-cards`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.listOfNetworkInterfaceCards ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const cofcPayload = {
    formatCOFC
};

export default cofcPayload;
